module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if ( 'pricerange' === filterGroup.type ) { ;
__p += '\n\n	';

		const range = filterGroup.filter.reduce( ( prev, filter ) => {

			prev.min = Math.floor( filter.range.min );
			prev.max = Math.ceil( filter.range.max );

			prev.from = Math.floor( filter.selected ? filter.range.from : filter.range.min );
			prev.to = Math.ceil( filter.selected ? filter.range.to : filter.range.max );

			prev.norm = [
				filter.range.norm_from ?? 0,
				filter.range.norm_to ?? 1
			];

			prev.currency = filter.currency;

			return prev;
		}, {} );

        const roundThreeDecimals = ( val ) =>  Math.round( val * 1000 ) / 1000;
	;
__p += '\n	<div class="en_price_select_wrapper">\n\n		<!-- module start: price_slider -->\n		<div class="mdl mdl_price_slider js-price-slider' +
((__t = ( filterGroup.nonlinear ? ' nonlinear' : '' )) == null ? '' : __t) +
'" data-real-min="' +
((__t = ( range.min )) == null ? '' : __t) +
'" data-real-max="' +
((__t = ( range.max )) == null ? '' : __t) +
'">\n			<div class="controls">\n\n				';
 if ( filterGroup.nonlinear ) { ;
__p += '\n					<input type="range" value="' +
((__t = ( roundThreeDecimals( range.norm[0] ) )) == null ? '' : __t) +
'" min="0" max="1" step="0.001" data-default="0" data-initial="' +
((__t = ( roundThreeDecimals( range.norm[0] ) )) == null ? '' : __t) +
'" />\n					<input type="range" value="' +
((__t = ( roundThreeDecimals( range.norm[1] ) )) == null ? '' : __t) +
'" min="0" max="1" step="0.001" data-default="1" data-initial="' +
((__t = ( roundThreeDecimals( range.norm[1] ) )) == null ? '' : __t) +
'" />\n				';
 } else { ;
__p += '\n					<input type="range" value="' +
((__t = ( range.from )) == null ? '' : __t) +
'" min="' +
((__t = ( range.min )) == null ? '' : __t) +
'" max="' +
((__t = ( range.max )) == null ? '' : __t) +
'" step="1" data-default="' +
((__t = ( range.min )) == null ? '' : __t) +
'" data-initial="' +
((__t = ( range.from )) == null ? '' : __t) +
'" />\n					<input type="range" value="' +
((__t = ( range.to   )) == null ? '' : __t) +
'" min="' +
((__t = ( range.min )) == null ? '' : __t) +
'" max="' +
((__t = ( range.max )) == null ? '' : __t) +
'" step="1" data-default="' +
((__t = ( range.max   )) == null ? '' : __t) +
'" data-initial="' +
((__t = ( range.to )) == null ? '' : __t) +
'" />\n				';
 } ;
__p += '\n\n				<input type="hidden" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'[min]" value="' +
((__t = ( range.min )) == null ? '' : __t) +
'" />\n				<input type="hidden" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'[max]" value="' +
((__t = ( range.max )) == null ? '' : __t) +
'" />\n\n				<input id="min-price" type="hidden" value="' +
((__t = ( range.from )) == null ? '' : __t) +
'" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'[from]" data-price-from />\n				<input id="max-price" type="hidden" value="' +
((__t = ( range.to   )) == null ? '' : __t) +
'" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'[to]"   data-price-to />\n			</div>\n			<div class="slider-inputs">\n				<input type="text" class="input" value="' +
((__t = ( EN_KO.functions.format_price( range.from, range.currency ) )) == null ? '' : __t) +
'" data-price-from data-price-format="true" />\n				<input type="text" class="input" value="' +
((__t = ( EN_KO.functions.format_price( range.to, range.currency ) )) == null ? '' : __t) +
'" data-price-to data-price-format="true" />\n			</div>\n		</div>\n		<!-- module end: price_slider -->\n	</div>\n';
 } else if ( 'category' === filterGroup.type ) {

	// Render Category Tree.
	const filterId = filter.filterId || [ filterGroup.identifier, index, filter.identifier ].join( '_' ).toLowerCase();

	// Special Setting for the category filter.
	const filterLabel = filter.name;
	const inputName = 'shop';

	const linkVals = filter.customfield1.split('/');
	const filterValue = linkVals[0];

	const hasChildren = filter.children && filter.children.length > 0;

	const className = [];
	if ( hasChildren ) {
		className.push( 'mdl_filter__field-tree-item--has-subcat' );
	}

	if ( filter.ancestor || filter.current || filterValue === filterGroup.filter[0].value ) {
		className.push( 'mdl_filter__field-tree--current' );
	}
;
__p += '\n\n	<li class="mdl_filter__field-tree-item ' +
((__t = ( className.join( ' ' ) )) == null ? '' : __t) +
'" data-menu="' +
((__t = ( filter.identifier )) == null ? '' : __t) +
'">\n		';
 if ( ! hasChildren ) { ;
__p += '\n			<input type="radio" class="mdl_filter__field-tree-item-input" id="' +
((__t = ( filterId )) == null ? '' : __t) +
'" name="' +
((__t = ( inputName )) == null ? '' : __t) +
'" data-initial="' +
((__t = ( filter.current )) == null ? '' : __t) +
'" data-default="' +
((__t = ( filter.current )) == null ? '' : __t) +
'" value=\'' +
((__t = ( filterValue )) == null ? '' : __t) +
'\' data-count="' +
((__t = ( filter.count )) == null ? '' : __t) +
'"' +
((__t = ( filter.current || filterValue === filterGroup.filter[0].value  ? ' checked' : '' )) == null ? '' : __t) +
' />\n		';
 } ;
__p += '\n		<label class="mdl_filter__field-tree-item-label"';
 if ( ! hasChildren ) { ;
__p += ' for="' +
((__t = ( filterId )) == null ? '' : __t) +
'"';
 };
__p += '>\n			<span class="mdl_filter__field-tree-item-inner">\n				<span class="mdl_filter__field-tree-item-title">' +
((__t = ( filterLabel )) == null ? '' : __t) +
' ';
 if ( filter.count ) { ;
__p += ' <span class="en_color--gray-inactive">(' +
((__t = ( EN_KO.functions.format_number( filter.count ) )) == null ? '' : __t) +
')</span>';
 } ;
__p += '</span>\n			</span>\n		</label>\n	</li>\n\n';
 } else {

	// Checkbox or Radio Items.
	const filterId = filter.filterId || [ filterGroup.input_name, index, filter.value ].join( '_' ).toLowerCase();

	// Get Label to show in List.
	const filterLabel = filter.label || filter.value;

	// Checkboxes are saved as array, radios with normal type.
	let inputName = filterGroup.input_name;
	if ( 'checkbox' === filterGroup.type ) {
		inputName = filterGroup.input_name + '[]';
	}

	const addClasses = [];
	if ( 'colors' === filterGroup.variant ) {
		addClasses.push( 'mdl_filter__field-choice--color' );
	}
	if ( filter.isChild ) {
		addClasses.push( 'mdl_filter__field-choice--sub' );
	}
;
__p += '\n	';
 if ( 'colors' === filterGroup.variant ) { ;
__p += '\n		<div class="mdl_filter__field-choice ' +
((__t = ( addClasses.join( ' ' ) )) == null ? '' : __t) +
'">\n			<input type="' +
((__t = ( filterGroup.type )) == null ? '' : __t) +
'" class="mdl_filter__field-choice-input" id="' +
((__t = ( filterId )) == null ? '' : __t) +
'" name="' +
((__t = ( inputName )) == null ? '' : __t) +
'" value="' +
((__t = ( filter.value )) == null ? '' : __t) +
'" data-count="' +
((__t = ( filter.count )) == null ? '' : __t) +
'" data-default="false" data-initial="' +
((__t = ( filter.selected )) == null ? '' : __t) +
'" ' +
((__t = ( filter.selected ? 'checked' : '' )) == null ? '' : __t) +
' />\n			<label class="mdl_filter__field-choice-label" for="' +
((__t = ( filterId )) == null ? '' : __t) +
'">\n				<span class="mdl_filter__field-choice-inner">\n					<span class="mdl_filter__field-choice-colordot" data-acl-color="' +
((__t = ( String( filter.value ).toLowerCase() )) == null ? '' : __t) +
'"></span>\n					<span class="mdl_filter__field-choice-title">' +
((__t = ( filterLabel )) == null ? '' : __t);
 if ( filter.count ) { ;
__p += ' <span class="en_color--gray-inactive">(' +
((__t = ( EN_KO.functions.format_number( filter.count ) )) == null ? '' : __t) +
')</span>';
 } ;
__p += '</span>\n				</span>\n			</label>\n		</div>\n	';
 } else { ;
__p += '\n		<div class="mdl_filter__field-choice ' +
((__t = ( addClasses.join( ' ' ) )) == null ? '' : __t) +
'">\n			<input type="' +
((__t = ( filterGroup.type )) == null ? '' : __t) +
'" class="mdl_filter__field-choice-input" id="' +
((__t = ( filterId )) == null ? '' : __t) +
'" name="' +
((__t = ( inputName )) == null ? '' : __t) +
'" value="' +
((__t = ( filter.value )) == null ? '' : __t) +
'" data-count="' +
((__t = ( filter.count )) == null ? '' : __t) +
'" data-default="' +
((__t = ( filterGroup.identifier === 'sortorder' && filter.value === 'bestseller|asc' )) == null ? '' : __t) +
'" data-initial="' +
((__t = ( filter.selected )) == null ? '' : __t) +
'" ' +
((__t = ( filter.selected ? 'checked' : '' )) == null ? '' : __t) +
' />\n			<label class="mdl_filter__field-choice-label" for="' +
((__t = ( filterId )) == null ? '' : __t) +
'">\n				<span class="mdl_filter__field-choice-inner">\n					<span class="mdl_filter__field-choice-title">' +
((__t = ( filterLabel )) == null ? '' : __t);
 if ( filter.count ) { ;
__p += ' <span class="en_color--gray-inactive">(' +
((__t = ( EN_KO.functions.format_number( filter.count ) )) == null ? '' : __t) +
')</span>';
 } ;
__p += '</span>\n				</span>\n			</label>\n		</div>\n	';
 } ;
__p += '\n';
 } ;
__p += '\n';

}
return __p
};
